import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../../state'
import * as rendering from '../../../../../rendering'
import * as componentStore from '../../component-store'
@ngCore.Component({
  imports: [
    ds.layout.widget.Component,
    ds.overlay.centered.Component,
    rendering.widget.Component,
    ds.input.select.singleEc.Component,
    ds.button.Component,
  ],
  selector: 'atn-mosaic-dev-widget-selector',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link componentStore.builder.Store} */
  public readonly store = ngCore.inject(componentStore.builder.Store)

  /** @see {@link state.mosaic.dev.widgets.Collection} */
  public readonly widgetEc = ngCore.inject(state.mosaic.dev.widgets.Collection)

  /** @see {@link state.mosaic.dev.widgets.plugins.preview.Plugin} */
  public readonly widgetPreviewPlugin = this.widgetEc.plugins
    .lookup(state.mosaic.dev.widgets.plugins.preview.Plugin)
    .get()

  /** Alias of the currently selected widget */
  public readonly selectedWidgetAliasSg = ngCore.computed(() =>
    this.widgetEc.plugins.selectionPlugin.feature.selectors
      .getFirstSelectedId({ target: this.store.widgetSelectionTarget })
      .asSignal(),
  )

  /** Preview of the selected widget */
  public readonly widgetPreviewSg = ngCore.computed(
    (selectedWidgetAlias = this.selectedWidgetAliasSg()) =>
      selectedWidgetAlias
        ? this.widgetPreviewPlugin.feature.selectors
            .getWidgetPreview({ alias: selectedWidgetAlias })
            .asSignal()
        : undefined,
  )

  /**
   * Handles the cancel action from the widget selector.
   * Clears the editing widget frame ID and discards any pending edits.
   */
  public cancelClickHandler(): void {
    this.store.setEditingWidget(undefined)
  }

  /**
   * Handles the save action for the widget frame editor.
   */
  public saveClickHandler(): void {
    const widgetPreview = this.widgetPreviewSg()
    if (widgetPreview?.alias) {
      this.store.applyWidgetRefToEditingWidgetFrame({
        widget: { alias: widgetPreview.alias },
      })
    }
    this.store.setEditingWidget(undefined)
  }
}
